import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { get } from "lodash";
import { shortDate, shortDateAndTimestamp } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import {
  CompanyName,
  DataTable,
  SearchPropTypes,
  LocationFlag,
  PartNumber
} from "MODULES/shared/components";
import { INCOMING_LINE_ITEMS } from "MODULES/IncomingQuotes/constants";
import { NoteTooltipTableCell } from "MODULES/shared/components/NoteTooltip";
import IconText from "MODULES/shared/components/IconText/IconText";
import { AsIsFlag } from "MODULES/IncomingQuotes/shared/AsIsFlag";
import { getFirstNameLastInitial } from "LIB/formatters/text";
import { ExchangeIcon } from "MODULES/PurchaseOrders/shared/ExchangeIcon";
import { DropshipIcon } from "MODULES/PurchaseOrders/shared/DropshipIcon";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";

function renderRow(lineItem, pushHistory) {
  const partiallyReceived =
    lineItem.quantity_received > 0 &&
    lineItem.quantity_received < lineItem.quantity;

  const classes = classNames("clickable", {
    "text-muted": lineItem.cancelled
  });

  return (
    <tr
      key={lineItem.id}
      className={classes}
      style={{ position: "relative" }}
      onClick={() =>
        pushHistory(`/purchase-orders/${lineItem.purchase_order.uuid}`)}
    >
      <td>
        <DropshipIcon
          shippingType={get(lineItem, "purchase_order.shipping_type")}
          exporting={get(lineItem, "purchase_order.exporting")}
          createdAt={get(lineItem, "purchase_order.created_at")}
        />
        {lineItem.purchase_order.code}
      </td>
      <td>{shortDateAndTimestamp(lineItem.created_at)}</td>
      <td>{shortDate(lineItem.date_received)}</td>
      <td>
        {lineItem.company && (
          <CompanyName company={lineItem.company} truncateAt={20} />
        )}
      </td>
      <td>
        {lineItem.buyer && getFirstNameLastInitial(lineItem.buyer.full_name)}
      </td>
      <td>
        {lineItem.co_buyer &&
          getFirstNameLastInitial(lineItem.co_buyer.full_name)}
      </td>
      <td>
        {lineItem.third_buyer &&
          getFirstNameLastInitial(lineItem.third_buyer.full_name)}
      </td>
      <td>{lineItem.invoice_number}</td>
      <MultiLocationFeature>
        <td className="text-center">
          <LocationFlag
            location={lineItem.purchase_order.buying_store_id}
            consignment_type={lineItem.consignment_type}
          />
        </td>
      </MultiLocationFeature>
      <td>
        {lineItem.has_vendor_rma && (
          <IconText icon="fa-shield" note="Vendor RMA" />
        )}
      </td>
      <td>{lineItem.part && <PartNumber part={lineItem.part} />}</td>
      <td>{lineItem.alternate && lineItem.alternate.name}</td>
      <td>
        {lineItem.condition &&
          INCOMING_LINE_ITEMS.condition[lineItem.condition].abbrev}
        <AsIsFlag lineItem={lineItem} className="m-l-5" />
      </td>
      <td className="text-center">{lineItem.quantity}</td>
      <td className="text-center">
        {lineItem.quantity_received}{" "}
        {partiallyReceived && <i className="fa fa-fw fa-btn fa-adjust" />}
      </td>
      <td className="text-center">{lineItem.lead_time}</td>
      <td className="text-center">
        <ExchangeIcon lineItem={lineItem} />
      </td>
      <td className="text-right">
        {dollars(
          lineItem.purchase_for_exchange && !lineItem.outright
            ? lineItem.exchange_fee
            : lineItem.cost
        )}
      </td>
      <td className="text-center">{lineItem.sellable_quantity}</td>
      <td>
        {[
          lineItem.purchase_for_repair && "Repair",
          lineItem.purchase_for_repair_assist && "Assist",
          lineItem.purchase_for_sale && "Sale",
          lineItem.purchase_for_stock && "Stock"
        ]
          .filter(Boolean)
          .join(", ")}
      </td>
      <NoteTooltipTableCell note={lineItem.last_po_note} />
    </tr>
  );
}

export function Table({ pushHistory, isLoading, pageActions, results }) {
  return (
    <DataTable loading={isLoading} refresh={pageActions.expire}>
      <DataTable.Head>
        <th>PO #</th>
        <th>Date Created</th>
        <th>Date Received</th>
        <th>Vendor</th>
        <th>Buyer</th>
        <th>Co-Buyer</th>
        <th>Third Buyer</th>
        <th>Inv #</th>
        <MultiLocationFeature>
          <th className="text-center">Store Owner</th>
        </MultiLocationFeature>
        <th />
        <th>Part #</th>
        <th>Buy As Alt</th>
        <th>CD</th>
        <th>Qty</th>
        <th>Qty Rec</th>
        <th>LT</th>
        <th className="text-center">Exch</th>
        <th className="text-right">EXCH FEE/COST EA</th>
        <th>Sellable Qty</th>
        <th>Purchased For</th>
        <th>Note</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(r => renderRow(r, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, {
  pushHistory: push
})(Table);



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Search/Table.jsx